//updates moved item location after drag-drop

export const rearrangeItems = <T>(
  fromItem: T[],
  toItem: T[],
  movedItem: T,
  dropOnItem: T,
  onRemove?: () => void, //throw an error in case removing that item is invalid
) => {
  const fromIndex = fromItem.findIndex((item) => item === movedItem);
  const toIndex = toItem.findIndex((item) => item === dropOnItem);
  const modifiedToIndex =
    fromItem === toItem && fromIndex !== -1 && fromIndex <= toIndex ? toIndex : toIndex + 1;

  onRemove ? onRemove() : fromItem.splice(fromIndex, 1);
  toItem.splice(toIndex === -1 ? 0 : modifiedToIndex, 0, movedItem!); // toIndex === -1 when dropped at 0 index of first level
};
